import gql from 'graphql-tag';

// TODO: move over relevant queries

export const videoCoursesQuery = gql`
  query VideoCoursesQuery($slug: String!) {
    CoursesV1Resource {
      slug(slug: $slug) {
        elements {
          id
          slug
          name
          premiumExperienceVariant
          certificates
          startDate
          description
          photoUrl
          plannedLaunchDate
          domainTypes {
            subdomainId
          }
          courseStatus
          instructorIds
          partnerIds
          partnerLogo
        }
      }
    }
  }
`;
